import { createFormHookContexts, createFormHook } from '@tanstack/react-form'
import { AmountSection } from 'commons/components/amount/index'
import { PaymentTypeSection } from 'commons/components/paymentType/index'
import { MotifSection } from 'commons/components/reason'
import { PhoneSection } from 'commons/components/phone/index'
import { EmailSection } from 'commons/components/email/index'
import { NameSection } from 'commons/components/name/index'
import { ValidationButton } from 'commons/components/ValidationButton'

export const { fieldContext, formContext, useFieldContext, useFormContext } =
	createFormHookContexts()

export const { useAppForm, withForm } = createFormHook({
	fieldContext,
	formContext,
	fieldComponents: {
		AmountSection,
		PaymentTypeSection,
		MotifSection,
		PhoneSection,
		EmailSection,
		NameSection
	},
	formComponents: {
		ValidationButton
	}
})
